import { useGetDocumentByIdQuery } from '@entities/common/commonQueries/index.ts';
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDocumentViewerPagesRedirect } from '@pages/main/DocumentViewer/helpers.ts';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { useMobile } from '@shared/hooks/index.ts';
import { ListBody, PageHead } from '@shared/ui';
import DescriptionViewer from '@shared/ui/viewer-note-editor-content/description-viewer/index.tsx';
import { Loader } from 'library/components/common';

export const DocumentViewer = () => {
  const { documentId } = useParams();
  const [searchParams] = useSearchParams();
  const wbb = searchParams.get('wbb');
  const { data } = useGetDocumentByIdQuery(documentId);
  const { doRedirectOnPrevPage } = useDocumentViewerPagesRedirect();
  const { isMobile } = useMobile();

  useEffect(() => {
    if (isMobile) {
      setTimeout(() => {
        const body = document.getElementById('body');
        setTimeout(() => body?.scrollIntoView(), 10);
      }, 0);
    }
  }, [data, isMobile]);

  return (
    <>
      <PageHead
        Left={wbb ? undefined : <PageBackButton onClick={() => doRedirectOnPrevPage('/')} />}
        Center={data?.name || 'Загрузка...'}
      />
      <ListBody>
        {data ? <DescriptionViewer description={data?.content} isAlwaysFull /> : <Loader />}
      </ListBody>
    </>
  );
};
